import { Table } from "@/features/Table";
import { type K2TimeSerie, columns } from "./columns";
import { type FilterK2TimeSeriesSchema, FilterK2TimeSeries } from "./filter";

const client = "k2";
const table_name = "k2_time_series";

export const K2TimeSeriesTable = () => {
  return (
    <Table<K2TimeSerie, FilterK2TimeSeriesSchema>
      label="Valorisation"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterK2TimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
